import { Vector3 } from "three";
import { MapConfig } from "../consts";
class Heightmap {
    image;
    maxHeight;
    context;
    /**
     * Heightmap applies a heightmap image to a geometry.
     * @param image the heightmap image.
     */
    constructor(image) {
        this.image = image;
        this.maxHeight = MapConfig.HEIGHTMAP_HEIGHT;
        this.context = this.createContext();
    }
    /**
     * Displace the y-level vertices of the input geometry based on the heightmap image.
     * @param geometry the input geometry.
     * @throws Error if the 2D rendering context is undefined.
     * @returns the displaced geometry.
     */
    apply(geometry) {
        if (this.context === null)
            throw new Error("Could not load heightmap: 2D canvas context is undefined.");
        const vertices = geometry.attributes.position.array;
        for (let i = 0; i < vertices.length; i += 3) {
            const vertex = new Vector3(vertices[i], vertices[i + 1], vertices[i + 2]);
            // adjust these values if the heightmap has a different resolution with bi-linear filtering.
            const u = (vertex.x + this.image.width * 0.5) / this.image.width;
            const v = (vertex.z + this.image.height * 0.5) / this.image.height;
            const pixelX = Math.floor(u * this.image.width);
            const pixelY = Math.floor(v * this.image.height);
            const pixelData = this.context.getImageData(pixelX, pixelY, 1, 1).data;
            const height = (pixelData[0] + pixelData[1] + pixelData[2]) / 3 / 255;
            vertices[i + 1] = height * this.maxHeight;
        }
        geometry.computeVertexNormals();
        return geometry;
    }
    /**
     * Create a 2D rendering context based on the heightmap image.
     * @returns the created 2D rendering context.
     */
    createContext() {
        const canvas = document.createElement("canvas");
        canvas.width = this.image.width;
        canvas.height = this.image.height;
        const context = canvas.getContext("2d", { willReadFrequently: true });
        context.drawImage(this.image, 0, 0);
        return context;
    }
}
export default Heightmap;
